import routerOptions0 from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/node_modules/.pnpm/nuxt@4.3.1_@parcel+watcher@2.5.6_@types+node@25.5.0_@vue+compiler-sfc@3.5.30_better-sql_608ee6d43a618caaf934593ecbea3b89/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/runner/work/EConnect.Web.Site/EConnect.Web.Site/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}